// export const backendUrl: string = 'http://localhost:3000/';
export const backendUrl: string = 'https://3airy4wtmk.execute-api.eu-west-1.amazonaws.com/prod/';
export const apiEndpoint: string = backendUrl + 'api/'
